var exports = {
  "x6": "x43aef4ae--fdda22--button",
  "pk": "x43aef4ae--fdda22--button_small",
  "Mg": "x43aef4ae--fdda22--button__icon",
  "cI": "x43aef4ae--fdda22--button_blue",
};

module.exports = exports;
